import React from 'react';
import LANGUAGES_CONTROLLER from '../../../controllers/languages';
import LanguageStringResolver from '../../fields/language/LanguageStringResolver';
import ProcessingStatusTag from '../shared/ProcessingStatusTag';
import InvoiceStatusTag from '../shared/InvoiceStatusTag';

const formatProcessingDate = (processingDate, languages) => {
    if (processingDate === null || processingDate === undefined) {
        return '-';
    }
    if (typeof processingDate !== 'string') {
        return LANGUAGES_CONTROLLER.format(languages, 'Unknown');
    }
    return processingDate.substring(0, 10) || '-';
};

export const DocumentItemPreview = ({ header, document, languages }) => {
    if (header) {
        return (
            <tr data-testid="uploaded-doc-preview-grid">
                <th className="filename-column"><LanguageStringResolver string="uploadedDocuments_fileName" /></th>
                <th className="status-column"><LanguageStringResolver string="uploadedDocuments_fileStatus" /></th>
                <th className="status-column"><LanguageStringResolver string="uploadedDocuments_invoiceStatus" /></th>
                <th className="date-column"><LanguageStringResolver string="uploadedDocuments_dateProcessed" /></th>
                <th><LanguageStringResolver string="uploadedDocuments_companyCode" /></th>
                <th><LanguageStringResolver string="uploadedDocuments_companyName" /></th>
                <th className="count-column"><LanguageStringResolver string="uploadedDocuments_processed" /></th>
                <th className="count-column"><LanguageStringResolver string="uploadedDocuments_error" /></th>
                <th className="count-column"><LanguageStringResolver string="uploadedDocuments_onHold" /></th>
                <th className="count-column"><LanguageStringResolver string="uploadedDocuments_pending" /></th>
                <th className="count-column"><LanguageStringResolver string="uploadedDocuments_totalNumber" /></th>
            </tr>
        );
    }

    if (!document) {
        return null;
    }

    const totalNumber = (document.processedCount || 0) +
        (document.errorCount || 0) +
        (document.onholdCount || 0) +
        (document.inboxCount || 0);

    return (
        <tr data-testid="uploaded-doc-preview-grid">
            <td className="filename-column">
                <span className="filename-text">{document.fileName}</span>
            </td>
            <td className="status-column">
                <ProcessingStatusTag document={document} showReason={false} languages={languages} />
            </td>
            <td className="status-column">
                <InvoiceStatusTag document={document} languages={languages} />
            </td>
            <td className="date-column">{formatProcessingDate(document.processingDate, languages)}</td>
            <td>{document.userCode || '-'}</td>
            <td className="name-column">{document.userName || '-'}</td>
            <td className="count-column">{document.processedCount}</td>
            <td className="count-column">{document.errorCount}</td>
            <td className="count-column">{document.onholdCount}</td>
            <td className="count-column">{document.inboxCount}</td>
            <td className="count-column">{totalNumber}</td>
        </tr>
    );
};


DocumentItemPreview.defaultProps = {
    header: false,
    languages: {}
};

export default DocumentItemPreview;
